import { Button, ButtonProps } from '@lfg/ui/components';

import { colors } from 'src/global/styles/colors';

export function SecondaryButton({ children, sx, ...rest }: ButtonProps) {
  return (
    <Button
      bgColor={colors.neutral06}
      wrapperSx={{
        marginTop: '0px !important',
      }}
      borderRadius={'4px'}
      sx={{
        textTransform: 'none',
        display: 'flex !important',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        fontSize: '16px',
        fontWeight: '500',
        padding: '14px 32px',
        marginTop: '0px',
        '&:disabled': {
          color: 'white',
          backgroundColor: colors.neutral06,
          opacity: 0.3,
          cursor: 'not-allowed',
        },
        '&:hover': {
          backgroundColor: '#31343B',
        },
        ...sx,
      }}
      variant='contained'
      fullWidth
      {...rest}>
      {children}
    </Button>
  );
}
